/* eslint-disable no-unused-expressions */
import axios from "axios"
import headers from "../../util/headers"

// Not working for some reason
// export const getProgramDetail = (baseUrl, program_id) => {
//   const path = `${baseUrl}/backend/programs/${program_id}`
//   return axios.get(path)
//     .then(({ data, status }) => ({ response: data, status }))
//     .catch(error => { error })
// }

export const getExportsList = (baseUrl, params) => {
  const path = `${baseUrl}/backend/exports`
  return axios.get(path, { params, ...headers() })
    .then(({ data, status, headers: resHeaders }) => ({ response: data, status, headers: resHeaders }))
    .catch(error => { error })
}

export const getProgramDetail = (baseUrl, program_id) => {
  const path = `${baseUrl}/backend/programs/details`
  return axios.get(path, { params: { id: program_id }, ...headers() })
    .then(({ data, status }) => ({ response: data, status }))
    .catch(error => { error })
}

export const getProgramStats = (baseUrl, params) => {
  const path = `${baseUrl}/backend/programs/stats`
  return axios.get(path, { params, ...headers() })
    .then(({ data, status }) => ({ response: data, status }))
    .catch(error => { error })
}

export const updateProgramDetail = (baseUrl, form) => {
  const path = `${baseUrl}/backend/programs/details`
  return axios.put(path, form, headers())
    .then(({ data, status }) => ({ response: data, status }))
    .catch(error => { error })
}

export const getPrograms = (baseUrl, params) => {
  const path = `${baseUrl}/backend/programs`
  return axios.get(path, { params, ...headers() })
    .then(({ data, status, headers: resHeaders }) => ({ response: data, status, headers: resHeaders }))
    .catch(error => { error })
}

export const createProgram = (baseUrl, program) => {
  const path = `${baseUrl}/backend/programs`
  return axios.post(path, program, headers())
    .then(({ data, status }) => ({ response: data, status }))
}

export const archiveProgram = (baseUrl, program_id, new_status) => {
  const path = `${baseUrl}/backend/programs/archive`
  return axios.post(path, { program_id, new_status }, headers())
    // .then(({ data, status }) => ({ response: data, status }))
    // .catch(error => { error })
}

export const addCalculator = (baseUrl, params) => {
  const path = `${baseUrl}/backend/programs/add_calculator`
  return axios.post(path, params, headers())
    .then(({ data, status }) => ({ response: data, status }))
}

export const getProgramsWithStats = baseUrl => {
  const path = `${baseUrl}/backend/programs/stats`
  return axios.get(path, headers())
    .then(({ data, status }) => ({ response: data, status }))
    .catch(error => { error })
}
